<div class="footer">
    <div class="container">
        <div class="row">
          <div class="container">
              <div class="row">
                  <div class="col-md-2">
                      <img src="assets/images/download.jpg" alt="">
                      <button class="btn btn-light">hello</button>
                  </div>
                  <div class="col-md-2">
                    <h3>The Basics</h3>  
          <ul>
            <li><a href="">About TMDb</a></li>
            <li><a href="">Contact Us</a></li>
            <li><a href="">Support Forums</a></li>
            <li><a href="">API</a></li>
            <li><a href="" target="_blank" rel="noopener">System Status</a></li>
          </ul>
                  </div>
              </div>
          </div>
        </div>
    </div>
</div>
